"use strict";
// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// source: underwriting/underwriting-service.proto
//
// GitHub:
// https://github.com/search?q=repo%3Agetstep%2Fserver+path%3Aproto%2Funderwriting%2Funderwriting-service.proto&type=code
Object.defineProperty(exports, "__esModule", { value: true });
exports.UnderwritingServiceClient = exports.lendingRequirementTypeToJSON = exports.lendingRequirementTypeFromJSON = exports.underwritingErrorCodeToJSON = exports.underwritingErrorCodeFromJSON = exports.GetDirectDepositTrackerResponse = exports.GetDirectDepositTrackerRequest = exports.CloseApplicationResponse = exports.CloseApplicationRequest = exports.GetCurrentApplicationResponse = exports.GetCurrentApplicationRequest = exports.GetSavedApplicationInfoResponse = exports.GetSavedApplicationInfoRequest = exports.CreateApplicationResponse = exports.CreateApplicationRequest = exports.ConsentToFlexCreditPullResponse = exports.ConsentToFlexCreditPullRequest = exports.GetCreditPullConsentAgreementResponse = exports.GetCreditPullConsentAgreementRequest = exports.GetUserEligibilityResponse = exports.GetUserEligibilityRequest = exports.CreateFlexAccountResponse = exports.CreateFlexAccountRequest = exports.GetCircuitBreakersResponse = exports.GetCircuitBreakersRequest = exports.GetAvailableProductsResponse = exports.GetAvailableProductsRequest = exports.LendingRequirement = exports.GetLendingRequirementsResponse = exports.GetLendingRequirementsRequest = exports.LendingRequirementType = exports.UnderwritingErrorCode = void 0;
/* eslint-disable */
const rpc_1 = require("@getstep/proto-lib/rpc");
const account_1 = require("../account/account");
const amount_1 = require("../common/amount");
const application_1 = require("./application");
const circuit_breakers_1 = require("./circuit-breakers");
const direct_deposit_tracker_1 = require("./direct-deposit-tracker");
const product_type_1 = require("./product-type");
const protobufPackage = 'com.step.underwriting.proto';
var UnderwritingErrorCode;
(function (UnderwritingErrorCode) {
    UnderwritingErrorCode["INVALID_ERROR_CODE"] = "INVALID_ERROR_CODE";
    UnderwritingErrorCode["UNSUPPORTED_REGION"] = "UNSUPPORTED_REGION";
    UnderwritingErrorCode["UNDERWRITING_CIRCUIT_BREAKER"] = "UNDERWRITING_CIRCUIT_BREAKER";
    UnderwritingErrorCode["UNRECOGNIZED"] = "UNRECOGNIZED";
})(UnderwritingErrorCode || (exports.UnderwritingErrorCode = UnderwritingErrorCode = {}));
var LendingRequirementType;
(function (LendingRequirementType) {
    LendingRequirementType["INVALID_REQUIREMENT_TYPE"] = "INVALID_REQUIREMENT_TYPE";
    /**
     * AGE - Indicates if the user has completed the onboarding.
     */
    LendingRequirementType["AGE"] = "AGE";
    /**
     * KYC - Indicates if the user has completed KYC.
     */
    LendingRequirementType["KYC"] = "KYC";
    /**
     * REGION - Will be set to false if the user is from unsupported region.
     */
    LendingRequirementType["REGION"] = "REGION";
    /**
     * DIRECT_DEPOSIT - If present, will indicate user's enrollment
     * in Direct Deposit.
     */
    LendingRequirementType["DIRECT_DEPOSIT"] = "DIRECT_DEPOSIT";
    /**
     * CIRCUIT_BREAKER - If set to false it indicates that lending
     * is disabled by the circuit breaker.
     */
    LendingRequirementType["CIRCUIT_BREAKER"] = "CIRCUIT_BREAKER";
    /**
     * RISK_SCORE - If set to false it indicates
     * that the user failed the risk score check.
     */
    LendingRequirementType["RISK_SCORE"] = "RISK_SCORE";
    LendingRequirementType["UNRECOGNIZED"] = "UNRECOGNIZED";
})(LendingRequirementType || (exports.LendingRequirementType = LendingRequirementType = {}));
function createBaseGetLendingRequirementsRequest() {
    return {};
}
exports.GetLendingRequirementsRequest = {
    fromJSON(_) {
        const message = {};
        return message;
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    create(base) {
        return exports.GetLendingRequirementsRequest.fromPartial(base ?? {});
    },
    fromPartial(_) {
        const message = createBaseGetLendingRequirementsRequest();
        return message;
    },
};
function createBaseGetLendingRequirementsResponse() {
    return { requirements: [] };
}
exports.GetLendingRequirementsResponse = {
    fromJSON(object) {
        const message = {
            requirements: globalThis.Array.isArray(object?.requirements)
                ? object.requirements.map((e) => exports.LendingRequirement.fromJSON(e))
                : [],
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.requirements?.length) {
            obj.requirements = message.requirements.map((e) => exports.LendingRequirement.toJSON(e));
        }
        return obj;
    },
    create(base) {
        return exports.GetLendingRequirementsResponse.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseGetLendingRequirementsResponse();
        message.requirements = object.requirements?.map((e) => exports.LendingRequirement.fromPartial(e)) || [];
        return message;
    },
};
function createBaseLendingRequirement() {
    return { type: LendingRequirementType.INVALID_REQUIREMENT_TYPE, confirmed: false };
}
exports.LendingRequirement = {
    fromJSON(object) {
        const message = {
            type: isSet(object.type)
                ? lendingRequirementTypeFromJSON(object.type)
                : LendingRequirementType.INVALID_REQUIREMENT_TYPE,
            confirmed: isSet(object.confirmed) ? globalThis.Boolean(object.confirmed) : false,
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.type !== LendingRequirementType.INVALID_REQUIREMENT_TYPE) {
            obj.type = lendingRequirementTypeToJSON(message.type);
        }
        if (message.confirmed !== false) {
            obj.confirmed = message.confirmed;
        }
        return obj;
    },
    create(base) {
        return exports.LendingRequirement.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseLendingRequirement();
        message.type = object.type ?? LendingRequirementType.INVALID_REQUIREMENT_TYPE;
        message.confirmed = object.confirmed ?? false;
        return message;
    },
};
function createBaseGetAvailableProductsRequest() {
    return {};
}
exports.GetAvailableProductsRequest = {
    fromJSON(_) {
        const message = {};
        return message;
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    create(base) {
        return exports.GetAvailableProductsRequest.fromPartial(base ?? {});
    },
    fromPartial(_) {
        const message = createBaseGetAvailableProductsRequest();
        return message;
    },
};
function createBaseGetAvailableProductsResponse() {
    return { products: [] };
}
exports.GetAvailableProductsResponse = {
    fromJSON(object) {
        const message = {
            products: globalThis.Array.isArray(object?.products)
                ? object.products.map((e) => (0, product_type_1.productTypeFromJSON)(e))
                : [],
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.products?.length) {
            obj.products = message.products.map((e) => (0, product_type_1.productTypeToJSON)(e));
        }
        return obj;
    },
    create(base) {
        return exports.GetAvailableProductsResponse.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseGetAvailableProductsResponse();
        message.products = object.products?.map((e) => e) || [];
        return message;
    },
};
function createBaseGetCircuitBreakersRequest() {
    return {};
}
exports.GetCircuitBreakersRequest = {
    fromJSON(_) {
        const message = {};
        return message;
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    create(base) {
        return exports.GetCircuitBreakersRequest.fromPartial(base ?? {});
    },
    fromPartial(_) {
        const message = createBaseGetCircuitBreakersRequest();
        return message;
    },
};
function createBaseGetCircuitBreakersResponse() {
    return { circuitBreakers: circuit_breakers_1.CircuitBreakers.fromPartial({}) };
}
exports.GetCircuitBreakersResponse = {
    fromJSON(object) {
        const message = {
            circuitBreakers: isSet(object.circuitBreakers)
                ? circuit_breakers_1.CircuitBreakers.fromJSON(object.circuitBreakers)
                : circuit_breakers_1.CircuitBreakers.fromPartial({}),
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.circuitBreakers !== undefined) {
            obj.circuitBreakers = circuit_breakers_1.CircuitBreakers.toJSON(message.circuitBreakers);
        }
        return obj;
    },
    create(base) {
        return exports.GetCircuitBreakersResponse.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseGetCircuitBreakersResponse();
        message.circuitBreakers =
            (object.circuitBreakers !== undefined && object.circuitBreakers !== null)
                ? circuit_breakers_1.CircuitBreakers.fromPartial(object.circuitBreakers)
                : circuit_breakers_1.CircuitBreakers.fromPartial({});
        return message;
    },
};
function createBaseCreateFlexAccountRequest() {
    return { creditFirst: false, selectedCreditLimit: undefined, includeCashAdvance: false };
}
exports.CreateFlexAccountRequest = {
    fromJSON(object) {
        const message = {};
        if (isSet(object.creditFirst)) {
            message.creditFirst = globalThis.Boolean(object.creditFirst);
        }
        if (isSet(object.selectedCreditLimit)) {
            message.selectedCreditLimit = amount_1.Amount.fromJSON(object.selectedCreditLimit);
        }
        if (isSet(object.includeCashAdvance)) {
            message.includeCashAdvance = globalThis.Boolean(object.includeCashAdvance);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.creditFirst !== undefined && message.creditFirst !== false) {
            obj.creditFirst = message.creditFirst;
        }
        if (message.selectedCreditLimit !== undefined) {
            obj.selectedCreditLimit = amount_1.Amount.toJSON(message.selectedCreditLimit);
        }
        if (message.includeCashAdvance !== undefined && message.includeCashAdvance !== false) {
            obj.includeCashAdvance = message.includeCashAdvance;
        }
        return obj;
    },
    create(base) {
        return exports.CreateFlexAccountRequest.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseCreateFlexAccountRequest();
        message.creditFirst = object.creditFirst ?? false;
        message.selectedCreditLimit =
            (object.selectedCreditLimit !== undefined && object.selectedCreditLimit !== null)
                ? amount_1.Amount.fromPartial(object.selectedCreditLimit)
                : undefined;
        message.includeCashAdvance = object.includeCashAdvance ?? false;
        return message;
    },
};
function createBaseCreateFlexAccountResponse() {
    return { account: account_1.Account.fromPartial({}) };
}
exports.CreateFlexAccountResponse = {
    fromJSON(object) {
        const message = {
            account: isSet(object.account) ? account_1.Account.fromJSON(object.account) : account_1.Account.fromPartial({}),
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.account !== undefined) {
            obj.account = account_1.Account.toJSON(message.account);
        }
        return obj;
    },
    create(base) {
        return exports.CreateFlexAccountResponse.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseCreateFlexAccountResponse();
        message.account = (object.account !== undefined && object.account !== null)
            ? account_1.Account.fromPartial(object.account)
            : account_1.Account.fromPartial({});
        return message;
    },
};
function createBaseGetUserEligibilityRequest() {
    return {};
}
exports.GetUserEligibilityRequest = {
    fromJSON(_) {
        const message = {};
        return message;
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    create(base) {
        return exports.GetUserEligibilityRequest.fromPartial(base ?? {});
    },
    fromPartial(_) {
        const message = createBaseGetUserEligibilityRequest();
        return message;
    },
};
function createBaseGetUserEligibilityResponse() {
    return { isEligible: false, creditLimit: amount_1.Amount.fromPartial({}), apr: '' };
}
exports.GetUserEligibilityResponse = {
    fromJSON(object) {
        const message = {
            isEligible: isSet(object.isEligible) ? globalThis.Boolean(object.isEligible) : false,
            creditLimit: isSet(object.creditLimit)
                ? amount_1.Amount.fromJSON(object.creditLimit)
                : amount_1.Amount.fromPartial({}),
            apr: isSet(object.apr) ? globalThis.String(object.apr) : '',
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.isEligible !== false) {
            obj.isEligible = message.isEligible;
        }
        if (message.creditLimit !== undefined) {
            obj.creditLimit = amount_1.Amount.toJSON(message.creditLimit);
        }
        if (message.apr !== '') {
            obj.apr = message.apr;
        }
        return obj;
    },
    create(base) {
        return exports.GetUserEligibilityResponse.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseGetUserEligibilityResponse();
        message.isEligible = object.isEligible ?? false;
        message.creditLimit = (object.creditLimit !== undefined && object.creditLimit !== null)
            ? amount_1.Amount.fromPartial(object.creditLimit)
            : amount_1.Amount.fromPartial({});
        message.apr = object.apr ?? '';
        return message;
    },
};
function createBaseGetCreditPullConsentAgreementRequest() {
    return {};
}
exports.GetCreditPullConsentAgreementRequest = {
    fromJSON(_) {
        const message = {};
        return message;
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    create(base) {
        return exports.GetCreditPullConsentAgreementRequest.fromPartial(base ?? {});
    },
    fromPartial(_) {
        const message = createBaseGetCreditPullConsentAgreementRequest();
        return message;
    },
};
function createBaseGetCreditPullConsentAgreementResponse() {
    return { copy: '', bnpl: '', flex: '' };
}
exports.GetCreditPullConsentAgreementResponse = {
    fromJSON(object) {
        const message = {
            bnpl: isSet(object.bnpl) ? globalThis.String(object.bnpl) : '',
            flex: isSet(object.flex) ? globalThis.String(object.flex) : '',
        };
        if (isSet(object.copy)) {
            message.copy = globalThis.String(object.copy);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.copy !== undefined && message.copy !== '') {
            obj.copy = message.copy;
        }
        if (message.bnpl !== '') {
            obj.bnpl = message.bnpl;
        }
        if (message.flex !== '') {
            obj.flex = message.flex;
        }
        return obj;
    },
    create(base) {
        return exports.GetCreditPullConsentAgreementResponse.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseGetCreditPullConsentAgreementResponse();
        message.copy = object.copy ?? '';
        message.bnpl = object.bnpl ?? '';
        message.flex = object.flex ?? '';
        return message;
    },
};
function createBaseConsentToFlexCreditPullRequest() {
    return {};
}
exports.ConsentToFlexCreditPullRequest = {
    fromJSON(_) {
        const message = {};
        return message;
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    create(base) {
        return exports.ConsentToFlexCreditPullRequest.fromPartial(base ?? {});
    },
    fromPartial(_) {
        const message = createBaseConsentToFlexCreditPullRequest();
        return message;
    },
};
function createBaseConsentToFlexCreditPullResponse() {
    return {};
}
exports.ConsentToFlexCreditPullResponse = {
    fromJSON(_) {
        const message = {};
        return message;
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    create(base) {
        return exports.ConsentToFlexCreditPullResponse.fromPartial(base ?? {});
    },
    fromPartial(_) {
        const message = createBaseConsentToFlexCreditPullResponse();
        return message;
    },
};
function createBaseCreateApplicationRequest() {
    return {
        employmentStatus: application_1.EmploymentStatus.INVALID_EMPLOYMENT_STATUS,
        annualIncome: undefined,
        info: undefined,
    };
}
exports.CreateApplicationRequest = {
    fromJSON(object) {
        const message = {};
        if (isSet(object.employmentStatus)) {
            message.employmentStatus = (0, application_1.employmentStatusFromJSON)(object.employmentStatus);
        }
        if (isSet(object.annualIncome)) {
            message.annualIncome = application_1.AnnualIncome.fromJSON(object.annualIncome);
        }
        if (isSet(object.info)) {
            message.info = application_1.BorrowerInfo.fromJSON(object.info);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.employmentStatus !== undefined &&
            message.employmentStatus !== application_1.EmploymentStatus.INVALID_EMPLOYMENT_STATUS) {
            obj.employmentStatus = (0, application_1.employmentStatusToJSON)(message.employmentStatus);
        }
        if (message.annualIncome !== undefined) {
            obj.annualIncome = application_1.AnnualIncome.toJSON(message.annualIncome);
        }
        if (message.info !== undefined) {
            obj.info = application_1.BorrowerInfo.toJSON(message.info);
        }
        return obj;
    },
    create(base) {
        return exports.CreateApplicationRequest.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseCreateApplicationRequest();
        message.employmentStatus = object.employmentStatus ??
            application_1.EmploymentStatus.INVALID_EMPLOYMENT_STATUS;
        message.annualIncome = (object.annualIncome !== undefined && object.annualIncome !== null)
            ? application_1.AnnualIncome.fromPartial(object.annualIncome)
            : undefined;
        message.info = (object.info !== undefined && object.info !== null)
            ? application_1.BorrowerInfo.fromPartial(object.info)
            : undefined;
        return message;
    },
};
function createBaseCreateApplicationResponse() {
    return { application: application_1.Application.fromPartial({}) };
}
exports.CreateApplicationResponse = {
    fromJSON(object) {
        const message = {
            application: isSet(object.application)
                ? application_1.Application.fromJSON(object.application)
                : application_1.Application.fromPartial({}),
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.application !== undefined) {
            obj.application = application_1.Application.toJSON(message.application);
        }
        return obj;
    },
    create(base) {
        return exports.CreateApplicationResponse.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseCreateApplicationResponse();
        message.application = (object.application !== undefined && object.application !== null)
            ? application_1.Application.fromPartial(object.application)
            : application_1.Application.fromPartial({});
        return message;
    },
};
function createBaseGetSavedApplicationInfoRequest() {
    return {};
}
exports.GetSavedApplicationInfoRequest = {
    fromJSON(_) {
        const message = {};
        return message;
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    create(base) {
        return exports.GetSavedApplicationInfoRequest.fromPartial(base ?? {});
    },
    fromPartial(_) {
        const message = createBaseGetSavedApplicationInfoRequest();
        return message;
    },
};
function createBaseGetSavedApplicationInfoResponse() {
    return { info: undefined };
}
exports.GetSavedApplicationInfoResponse = {
    fromJSON(object) {
        const message = {};
        if (isSet(object.info)) {
            message.info = application_1.BorrowerInfo.fromJSON(object.info);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.info !== undefined) {
            obj.info = application_1.BorrowerInfo.toJSON(message.info);
        }
        return obj;
    },
    create(base) {
        return exports.GetSavedApplicationInfoResponse.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseGetSavedApplicationInfoResponse();
        message.info = (object.info !== undefined && object.info !== null)
            ? application_1.BorrowerInfo.fromPartial(object.info)
            : undefined;
        return message;
    },
};
function createBaseGetCurrentApplicationRequest() {
    return {};
}
exports.GetCurrentApplicationRequest = {
    fromJSON(_) {
        const message = {};
        return message;
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    create(base) {
        return exports.GetCurrentApplicationRequest.fromPartial(base ?? {});
    },
    fromPartial(_) {
        const message = createBaseGetCurrentApplicationRequest();
        return message;
    },
};
function createBaseGetCurrentApplicationResponse() {
    return { application: undefined };
}
exports.GetCurrentApplicationResponse = {
    fromJSON(object) {
        const message = {};
        if (isSet(object.application)) {
            message.application = application_1.Application.fromJSON(object.application);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.application !== undefined) {
            obj.application = application_1.Application.toJSON(message.application);
        }
        return obj;
    },
    create(base) {
        return exports.GetCurrentApplicationResponse.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseGetCurrentApplicationResponse();
        message.application = (object.application !== undefined && object.application !== null)
            ? application_1.Application.fromPartial(object.application)
            : undefined;
        return message;
    },
};
function createBaseCloseApplicationRequest() {
    return { applicationId: '', acceptedProduct: product_type_1.ProductType.INVALID_PRODUCT_TYPE };
}
exports.CloseApplicationRequest = {
    fromJSON(object) {
        const message = {
            applicationId: isSet(object.applicationId) ? globalThis.String(object.applicationId) : '',
        };
        if (isSet(object.acceptedProduct)) {
            message.acceptedProduct = (0, product_type_1.productTypeFromJSON)(object.acceptedProduct);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.applicationId !== '') {
            obj.applicationId = message.applicationId;
        }
        if (message.acceptedProduct !== undefined &&
            message.acceptedProduct !== product_type_1.ProductType.INVALID_PRODUCT_TYPE) {
            obj.acceptedProduct = (0, product_type_1.productTypeToJSON)(message.acceptedProduct);
        }
        return obj;
    },
    create(base) {
        return exports.CloseApplicationRequest.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseCloseApplicationRequest();
        message.applicationId = object.applicationId ?? '';
        message.acceptedProduct = object.acceptedProduct ?? product_type_1.ProductType.INVALID_PRODUCT_TYPE;
        return message;
    },
};
function createBaseCloseApplicationResponse() {
    return { application: application_1.Application.fromPartial({}) };
}
exports.CloseApplicationResponse = {
    fromJSON(object) {
        const message = {
            application: isSet(object.application)
                ? application_1.Application.fromJSON(object.application)
                : application_1.Application.fromPartial({}),
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.application !== undefined) {
            obj.application = application_1.Application.toJSON(message.application);
        }
        return obj;
    },
    create(base) {
        return exports.CloseApplicationResponse.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseCloseApplicationResponse();
        message.application = (object.application !== undefined && object.application !== null)
            ? application_1.Application.fromPartial(object.application)
            : application_1.Application.fromPartial({});
        return message;
    },
};
function createBaseGetDirectDepositTrackerRequest() {
    return {};
}
exports.GetDirectDepositTrackerRequest = {
    fromJSON(_) {
        const message = {};
        return message;
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    create(base) {
        return exports.GetDirectDepositTrackerRequest.fromPartial(base ?? {});
    },
    fromPartial(_) {
        const message = createBaseGetDirectDepositTrackerRequest();
        return message;
    },
};
function createBaseGetDirectDepositTrackerResponse() {
    return { tracker: direct_deposit_tracker_1.DirectDepositTracker.fromPartial({}) };
}
exports.GetDirectDepositTrackerResponse = {
    fromJSON(object) {
        const message = {
            tracker: isSet(object.tracker)
                ? direct_deposit_tracker_1.DirectDepositTracker.fromJSON(object.tracker)
                : direct_deposit_tracker_1.DirectDepositTracker.fromPartial({}),
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.tracker !== undefined) {
            obj.tracker = direct_deposit_tracker_1.DirectDepositTracker.toJSON(message.tracker);
        }
        return obj;
    },
    create(base) {
        return exports.GetDirectDepositTrackerResponse.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseGetDirectDepositTrackerResponse();
        message.tracker = (object.tracker !== undefined && object.tracker !== null)
            ? direct_deposit_tracker_1.DirectDepositTracker.fromPartial(object.tracker)
            : direct_deposit_tracker_1.DirectDepositTracker.fromPartial({});
        return message;
    },
};
function underwritingErrorCodeFromJSON(object) {
    switch (object) {
        case 0:
        case 'INVALID_ERROR_CODE':
            return UnderwritingErrorCode.INVALID_ERROR_CODE;
        case 1:
        case 'UNSUPPORTED_REGION':
            return UnderwritingErrorCode.UNSUPPORTED_REGION;
        case 2:
        case 'UNDERWRITING_CIRCUIT_BREAKER':
            return UnderwritingErrorCode.UNDERWRITING_CIRCUIT_BREAKER;
        case -1:
        case 'UNRECOGNIZED':
        default:
            return UnderwritingErrorCode.UNRECOGNIZED;
    }
}
exports.underwritingErrorCodeFromJSON = underwritingErrorCodeFromJSON;
function underwritingErrorCodeToJSON(object) {
    switch (object) {
        case UnderwritingErrorCode.INVALID_ERROR_CODE:
            return 'INVALID_ERROR_CODE';
        case UnderwritingErrorCode.UNSUPPORTED_REGION:
            return 'UNSUPPORTED_REGION';
        case UnderwritingErrorCode.UNDERWRITING_CIRCUIT_BREAKER:
            return 'UNDERWRITING_CIRCUIT_BREAKER';
        case UnderwritingErrorCode.UNRECOGNIZED:
        default:
            return 'UNRECOGNIZED';
    }
}
exports.underwritingErrorCodeToJSON = underwritingErrorCodeToJSON;
function lendingRequirementTypeFromJSON(object) {
    switch (object) {
        case 0:
        case 'INVALID_REQUIREMENT_TYPE':
            return LendingRequirementType.INVALID_REQUIREMENT_TYPE;
        case 1:
        case 'AGE':
            return LendingRequirementType.AGE;
        case 2:
        case 'KYC':
            return LendingRequirementType.KYC;
        case 3:
        case 'REGION':
            return LendingRequirementType.REGION;
        case 4:
        case 'DIRECT_DEPOSIT':
            return LendingRequirementType.DIRECT_DEPOSIT;
        case 5:
        case 'CIRCUIT_BREAKER':
            return LendingRequirementType.CIRCUIT_BREAKER;
        case 6:
        case 'RISK_SCORE':
            return LendingRequirementType.RISK_SCORE;
        case -1:
        case 'UNRECOGNIZED':
        default:
            return LendingRequirementType.UNRECOGNIZED;
    }
}
exports.lendingRequirementTypeFromJSON = lendingRequirementTypeFromJSON;
function lendingRequirementTypeToJSON(object) {
    switch (object) {
        case LendingRequirementType.INVALID_REQUIREMENT_TYPE:
            return 'INVALID_REQUIREMENT_TYPE';
        case LendingRequirementType.AGE:
            return 'AGE';
        case LendingRequirementType.KYC:
            return 'KYC';
        case LendingRequirementType.REGION:
            return 'REGION';
        case LendingRequirementType.DIRECT_DEPOSIT:
            return 'DIRECT_DEPOSIT';
        case LendingRequirementType.CIRCUIT_BREAKER:
            return 'CIRCUIT_BREAKER';
        case LendingRequirementType.RISK_SCORE:
            return 'RISK_SCORE';
        case LendingRequirementType.UNRECOGNIZED:
        default:
            return 'UNRECOGNIZED';
    }
}
exports.lendingRequirementTypeToJSON = lendingRequirementTypeToJSON;
class UnderwritingServiceClient {
    rpc;
    name = 'com.step.underwriting.proto.UnderwritingService';
    type = rpc_1.ServiceType.PUBLIC;
    path = '/underwriting';
    methods = [{
            name: 'GetLendingRequirements',
            requestType: exports.GetLendingRequirementsRequest,
            responseType: exports.GetLendingRequirementsResponse,
            authenticationOptions: { level: rpc_1.AuthLevel.LOW },
        }, {
            name: 'GetAvailableProducts',
            requestType: exports.GetAvailableProductsRequest,
            responseType: exports.GetAvailableProductsResponse,
            authenticationOptions: { level: rpc_1.AuthLevel.LOW },
        }, {
            name: 'GetCircuitBreakers',
            requestType: exports.GetCircuitBreakersRequest,
            responseType: exports.GetCircuitBreakersResponse,
            authenticationOptions: { level: rpc_1.AuthLevel.LOW },
        }, {
            name: 'CreateFlexAccount',
            requestType: exports.CreateFlexAccountRequest,
            responseType: exports.CreateFlexAccountResponse,
            authenticationOptions: { level: rpc_1.AuthLevel.STRONG },
        }, {
            name: 'GetUserEligibility',
            requestType: exports.GetUserEligibilityRequest,
            responseType: exports.GetUserEligibilityResponse,
            authenticationOptions: { level: rpc_1.AuthLevel.LOW },
        }, {
            name: 'GetCreditPullConsentAgreement',
            requestType: exports.GetCreditPullConsentAgreementRequest,
            responseType: exports.GetCreditPullConsentAgreementResponse,
            authenticationOptions: { level: rpc_1.AuthLevel.LOW },
        }, {
            name: 'ConsentToFlexCreditPull',
            requestType: exports.ConsentToFlexCreditPullRequest,
            responseType: exports.ConsentToFlexCreditPullResponse,
            authenticationOptions: { level: rpc_1.AuthLevel.LOW },
        }, {
            name: 'CreateApplication',
            requestType: exports.CreateApplicationRequest,
            responseType: exports.CreateApplicationResponse,
            authenticationOptions: { level: rpc_1.AuthLevel.LOW },
        }, {
            name: 'GetCurrentApplication',
            requestType: exports.GetCurrentApplicationRequest,
            responseType: exports.GetCurrentApplicationResponse,
            authenticationOptions: { level: rpc_1.AuthLevel.LOW },
        }, {
            name: 'GetSavedApplicationInfo',
            requestType: exports.GetSavedApplicationInfoRequest,
            responseType: exports.GetSavedApplicationInfoResponse,
            authenticationOptions: { level: rpc_1.AuthLevel.LOW },
        }, {
            name: 'CloseApplication',
            requestType: exports.CloseApplicationRequest,
            responseType: exports.CloseApplicationResponse,
            authenticationOptions: { level: rpc_1.AuthLevel.STRONG },
        }, {
            name: 'GetDirectDepositTracker',
            requestType: exports.GetDirectDepositTrackerRequest,
            responseType: exports.GetDirectDepositTrackerResponse,
            authenticationOptions: { level: rpc_1.AuthLevel.LOW },
        }];
    constructor(rpc) {
        this.rpc = rpc;
    }
    /**
     * Returns requirements that must be met for the lending to be available.
     */
    getLendingRequirements(request, options = {}) {
        return this.rpc.call({
            path: this.path,
            service: this,
            method: this.methods[0],
            data: request,
            headers: {},
            context: {},
        }, options);
    }
    /**
     * Returns list of available products.
     */
    getAvailableProducts(request, options = {}) {
        return this.rpc.call({
            path: this.path,
            service: this,
            method: this.methods[1],
            data: request,
            headers: {},
            context: {},
        }, options);
    }
    /**
     * Returns the state of the circuit breakers.
     */
    getCircuitBreakers(request, options = {}) {
        return this.rpc.call({
            path: this.path,
            service: this,
            method: this.methods[2],
            data: request,
            headers: {},
            context: {},
        }, options);
    }
    /**
     * Opens a Flex account.
     */
    createFlexAccount(request, options = {}) {
        return this.rpc.call({
            path: this.path,
            service: this,
            method: this.methods[3],
            data: request,
            headers: {},
            context: {},
        }, options);
    }
    /**
     * Returns the user's Flex eligibility.
     */
    getUserEligibility(request, options = {}) {
        return this.rpc.call({
            path: this.path,
            service: this,
            method: this.methods[4],
            data: request,
            headers: {},
            context: {},
        }, options);
    }
    /**
     * Returns the latest copy of the credit pull consent agreement.
     */
    getCreditPullConsentAgreement(request, options = {}) {
        return this.rpc.call({
            path: this.path,
            service: this,
            method: this.methods[5],
            data: request,
            headers: {},
            context: {},
        }, options);
    }
    /**
     * Records the user's consent to a credit pull for Flex Beta.
     */
    consentToFlexCreditPull(request, options = {}) {
        return this.rpc.call({
            path: this.path,
            service: this,
            method: this.methods[6],
            data: request,
            headers: {},
            context: {},
        }, options);
    }
    /**
     * Creates new credit line application.
     */
    createApplication(request, options = {}) {
        return this.rpc.call({
            path: this.path,
            service: this,
            method: this.methods[7],
            data: request,
            headers: {},
            context: {},
        }, options);
    }
    /**
     * Returns current credit line application, if any.
     */
    getCurrentApplication(request, options = {}) {
        return this.rpc.call({
            path: this.path,
            service: this,
            method: this.methods[8],
            data: request,
            headers: {},
            context: {},
        }, options);
    }
    /**
     * Returns application data from the last application, if any.
     */
    getSavedApplicationInfo(request, options = {}) {
        return this.rpc.call({
            path: this.path,
            service: this,
            method: this.methods[9],
            data: request,
            headers: {},
            context: {},
        }, options);
    }
    /**
     * Close credit line application offer and optionally accept one of the products.
     */
    closeApplication(request, options = {}) {
        return this.rpc.call({
            path: this.path,
            service: this,
            method: this.methods[10],
            data: request,
            headers: {},
            context: {},
        }, options);
    }
    /**
     * Get direct deposit tracker status.
     */
    getDirectDepositTracker(request, options = {}) {
        return this.rpc.call({
            path: this.path,
            service: this,
            method: this.methods[11],
            data: request,
            headers: {},
            context: {},
        }, options);
    }
}
exports.UnderwritingServiceClient = UnderwritingServiceClient;
function isSet(value) {
    return value !== null && value !== undefined;
}
//# sourceMappingURL=underwriting-service.js.map